import React, { useState } from "react";
import styles from './ChangePassword.module.scss';
import PageTitle from "../../components/pageTitle/PageTitle";
import ChangePasswordForm from "../../components/changePasswordForm/ChangePasswordForm";
import axiosClient from "../../api/axiosClient";
import LoadingOverlay from "../../components/loadingOverlay/LoadingOverlay";

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  })
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handlePassword = async ({
    oldPassword,
    newPassword
  }) => {
    setIsLoading(true);
    setError('');
    setSuccess('');
    await axiosClient.patch(`users/profile/change-password`, {
      oldPassword,
      newPassword
    })
    .then((response) => {
      setSuccess(response.message || 'Password Updated Successfully');
      setFormData({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      })
    })
    .catch((error) => {
      setError(error.message);
    })
    .finally(() => {
      setIsLoading(false);
    });
  }

  return (
    <div className={styles.container}>
      {isLoading && <LoadingOverlay />}
      <PageTitle
        label="Change Password"
        menu="profile"
      />
      <ChangePasswordForm
        formData={formData}
        onSubmit={handlePassword}
        error={error}
        success={success}
      />
    </div>
  );
};

export default ChangePassword;